/* tslint:disable */
/* eslint-disable */
/**
 * Donio
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Donation
 */
export interface Donation {
    /**
     * 
     * @type {string}
     * @memberof Donation
     */
    id: string;
    /**
     * Will be filled only in case when a request is authorized by the donor (via User account or knowledge of publicId)
     * @type {string}
     * @memberof Donation
     */
    publicId: string | null;
    /**
     * 
     * @type {string}
     * @memberof Donation
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof Donation
     */
    subprojectId: string | null;
    /**
     * Price in cents (1/100 of base unit of currency)
     * @type {number}
     * @memberof Donation
     */
    amountInCents: number;
    /**
     * Price in cents (1/100 of base unit of currency)
     * @type {number}
     * @memberof Donation
     */
    tipInCents: number;
    /**
     * Either user's filled name when adding comment or random generated one.
     * @type {string}
     * @memberof Donation
     */
    donorName: string;
    /**
     * 
     * @type {string}
     * @memberof Donation
     */
    donorComment: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Donation
     */
    isCommentVisible: boolean;
    /**
     * 
     * @type {Date}
     * @memberof Donation
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Donation
     */
    paidAt: Date | null;
    /**
     * 
     * @type {string}
     * @memberof Donation
     */
    status: DonationStatusEnum;
}


/**
 * @export
 */
export const DonationStatusEnum = {
    New: 'new',
    Paid: 'paid',
    Cancelled: 'cancelled',
    Refunded: 'refunded',
    RefundedWithoutTip: 'refunded-without-tip'
} as const;
export type DonationStatusEnum = typeof DonationStatusEnum[keyof typeof DonationStatusEnum];


/**
 * Check if a given object implements the Donation interface.
 */
export function instanceOfDonation(value: object): value is Donation {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('publicId' in value) || value['publicId'] === undefined) return false;
    if (!('projectId' in value) || value['projectId'] === undefined) return false;
    if (!('subprojectId' in value) || value['subprojectId'] === undefined) return false;
    if (!('amountInCents' in value) || value['amountInCents'] === undefined) return false;
    if (!('tipInCents' in value) || value['tipInCents'] === undefined) return false;
    if (!('donorName' in value) || value['donorName'] === undefined) return false;
    if (!('donorComment' in value) || value['donorComment'] === undefined) return false;
    if (!('isCommentVisible' in value) || value['isCommentVisible'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('paidAt' in value) || value['paidAt'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function DonationFromJSON(json: any): Donation {
    return DonationFromJSONTyped(json, false);
}

export function DonationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Donation {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'publicId': json['publicId'],
        'projectId': json['projectId'],
        'subprojectId': json['subprojectId'],
        'amountInCents': json['amountInCents'],
        'tipInCents': json['tipInCents'],
        'donorName': json['donorName'],
        'donorComment': json['donorComment'],
        'isCommentVisible': json['isCommentVisible'],
        'createdAt': (new Date(json['createdAt'])),
        'paidAt': (json['paidAt'] == null ? null : new Date(json['paidAt'])),
        'status': json['status'],
    };
}

export function DonationToJSON(json: any): Donation {
    return DonationToJSONTyped(json, false);
}

export function DonationToJSONTyped(value?: Donation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'publicId': value['publicId'],
        'projectId': value['projectId'],
        'subprojectId': value['subprojectId'],
        'amountInCents': value['amountInCents'],
        'tipInCents': value['tipInCents'],
        'donorName': value['donorName'],
        'donorComment': value['donorComment'],
        'isCommentVisible': value['isCommentVisible'],
        'createdAt': ((value['createdAt']).toISOString()),
        'paidAt': (value['paidAt'] == null ? null : (value['paidAt'] as any).toISOString()),
        'status': value['status'],
    };
}

